import TopNavBar from '../components/navigation/TopNavBar'
import RoundedButtonLink from '../components/buttons/RoundedButtonLink'
import notFound from '../assets/not-found.png'
import strings from '../res/strings'

const NotFound = () => {
    return (
        <>
            <TopNavBar />

            <div className='h-screen flex flex-col justify-center items-center'>
                <p className='font-montserrat text-3xl font-bold text-accent'>{strings.error}</p>
                <p className='font-montserrat mt-1'>{strings.notFound}</p>
                <img className='h-[21.188rem] w-[28.688rem]' src={notFound} alt='Página não encontrada'/>

                <div className='mt-16 w-[18.75rem]'>
                    <RoundedButtonLink 
                        path='/'
                        text={strings.backMainPage}
                        height={48}
                        bgColor='#007EB4'
                        flex={true}
                    />
                </div>
            </div>
        </>
    )
}

export default NotFound